import styled from 'styled-components'

const MainButton = styled.a`
    background-color: #F64740;
    color: #fff !important;
    padding: 14px;
    border-radius: 5px;
    text-decoration: none;
    font-weight: 700;
    cursor: pointer;
    font-size: 0.9rem;
  :hover {
    background-color: #f86863 !important;
  }
`
export default MainButton;